import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  Box,
  MainHeading,
  Span,
  SpanStyled,
  SubHeading,
  TextStyled,
} from "../../Styled/Elements";
import { ArrowDown2, ArrowDown3, ArrowRight2, ArrowUp2, ArrowUp3, Minus, Plus } from "../../Styled/AllImages";
import { FaqsWrapper } from "./Styled";

const Faqs = ({ data }) => {
  const { t } = useTranslation();
  const [activeItem, setActiveItem] = useState(0);
  const [faqList, setFaqList] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const toggleItem = (index) => {
    setActiveItem(activeItem === index ? null : index);
  };

  const handleFAQList = () => {
    setShowMore((prevState) => !prevState);
  };
  const displayedFaqs = showMore ? faqList : faqList.slice(0, 4);

  useEffect(() => {
    if (data && data.length) setFaqList(data);
  }, [data]);

  return (
    <>
      <FaqsWrapper className="container-fluid common-space faqsFluid" id="faqs">
        <Container>
          <Row className="faqsRow">
            <Col md={12}>
              <SubHeading className="sub-heading">
                {t("YourQuestionsAnswered")}
              </SubHeading>
              <MainHeading className="main-heading">
                {t("EverythingKnow")}
              </MainHeading>
            </Col>
            <Col lg={12} className="sliderWrapper">
              {displayedFaqs.length > 0 &&
                displayedFaqs.map((list, index) => (
                  <Box
                    key={index}
                    className={`item-container  ${
                      activeItem === index ? "active-item-box" : ""
                    }`}
                    onClick={() => toggleItem(index)}
                  >
                    <Box className="item-box">
                      <Span className="d-flex gap-2 align-items-center item-box-heading">
                        {t(list.question)}
                      </Span>
                      {activeItem === index ? <Minus /> : <Plus />}
                    </Box>
                    {activeItem === index && (
                      <Box>
                        <Box>
                          <TextStyled className="item-box-text">
                            {t(list.answer)}
                          </TextStyled>
                        </Box>
                      </Box>
                    )}
                  </Box>
                ))}
            </Col>
          </Row>
          {faqList.length > 4 && (
            <Box className="d-flex justify-content-center my-5 d-inline-block">
              <SpanStyled
                className="more-btn"
                color="var(--darkColor)"
                weight="400"
                onClick={handleFAQList}
              >
                {showMore ? (
                  <>
                    {t("show_less")} <ArrowUp3 className="mx-2" />
                  </>
                ) : (
                  <>
                    {t("show_more")} <ArrowDown3 className="mx-2" />
                  </>
                )}
              </SpanStyled>
            </Box>
          )}
        </Container>
      </FaqsWrapper>
    </>
  );
};

export default Faqs;
